module.exports = __webpack_public_path__ + "img/tv.8b2da78d.svg";